import { fetch } from '@atlassian/eoc-fetch';

import {
	type AiNotificationPolicy,
	type AiNotificationPolicyResponse,
	type ChangeAiNotificationPolicyOrderParams,
	type ChangeAiNotificationPolicyStateParams,
	type CreateAiNotificationPolicyParams,
	type DeleteAiNotificationPolicyParams,
	type UpdateAiNotificationPolicyParams,
} from '../../../../common/types';

export const getGlobalGroupNotificationPolicies = (): Promise<AiNotificationPolicyResponse> => {
	return fetch<AiNotificationPolicyResponse>(`/v1/alerts/ai-notification-policies`);
};

export const changeGlobalGroupNotificationPolicyOrderEndpoint = (
	payload: ChangeAiNotificationPolicyOrderParams,
): Promise<Response> => {
	return fetch(`/v1/alerts/ai-notification-policies/${payload.id}/order`, {
		method: 'PATCH',
		body: { after: payload.after },
		responseType: 'headers',
	});
};

export const enableGlobalGroupNotificationPolicyEndpoint = (
	payload: ChangeAiNotificationPolicyStateParams,
): Promise<Response> => {
	return fetch(`/v1/alerts/ai-notification-policies/${payload.id}/enable`, {
		method: 'POST',
		responseType: 'headers',
	});
};

export const disableGlobalGroupNotificationPolicyEndpoint = (
	payload: ChangeAiNotificationPolicyStateParams,
): Promise<Response> => {
	return fetch(`/v1/alerts/ai-notification-policies/${payload.id}/disable`, {
		method: 'POST',
		responseType: 'headers',
	});
};

export const deleteGlobalGroupNotificationPolicyEndpoint = (
	payload: DeleteAiNotificationPolicyParams,
): Promise<Response> => {
	return fetch(`/v1/alerts/ai-notification-policies/${payload.id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};

export const createGlobalGroupNotificationPolicyEndpoint = (
	payload: CreateAiNotificationPolicyParams,
): Promise<AiNotificationPolicy> => {
	return fetch<AiNotificationPolicy>(`/v1/alerts/ai-notification-policies`, {
		method: 'POST',
		body: payload,
	});
};

export const updateGlobalGroupNotificationPolicyEndpoint = (
	payload: UpdateAiNotificationPolicyParams,
): Promise<AiNotificationPolicy> => {
	return fetch<AiNotificationPolicy>(`/v1/alerts/ai-notification-policies/${payload.id}`, {
		method: 'PUT',
		body: payload,
	});
};
